import { Box, Divider, Grid, Paper } from "@mui/material";
import { UseFormSetValue, UseFormWatch, useForm } from "react-hook-form";

import Field from "./Field";
import Footer from "./Footer";
import Swal from "sweetalert2";

type TField = {
  label: string;
  type: string;
  name: string;
  defaultValue?: any;
  disabled?: boolean;
  inputOptions?: any;
  maxLength?: number;
  tooltip?: string;
  col?: number;
  items?: {
    label: any;
    value: any;
    checked?: boolean;
  }[];
};
interface Props {
  type: "create" | "edit" | "detail";
  fields: TField[];
  onSubmit?: (data: any) => void;
  onBack: () => void;
  onForm?: (watch: UseFormWatch<any>, setValue: UseFormSetValue<any>) => void;
  content?: React.ReactNode;
}

const defaultOnSubmit = (data: any) => {
  console.log("data form: ", data);
};

const FieldList: React.FC<Props> = ({
  onSubmit = defaultOnSubmit,
  fields,
  type,
  onBack,
  onForm,
  content,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm<any>();

  const onConfirm = (data: any) => {
    Swal.fire({
      icon: "warning",
      html: `ต้องการ${type === "create" ? "สร้าง" : "แก้ไข"}ใช่ หรือไม่?`,
      showCancelButton: true,
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        onSubmit(data);
      }
    });
  };

  return (
    <Paper>
      <form onSubmit={handleSubmit(onConfirm)}>
        <Box
          sx={{
            p: 2,
          }}
        >
          <Grid container spacing={2}>
            {fields.map((field, index) => {
              return (
                <Grid key={index + 1} item xs={field.col || 12}>
                  <Field
                    {...field}
                    fieldListType={type}
                    form={{
                      register,
                      setValue,
                      watch,
                      setError,
                      clearErrors,
                    }}
                    error={!!errors[field.name]}
                    errorMessage={errors[field.name]?.message as string}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        {content ? <Box>{content}</Box> : null}
        <Divider />
        <Footer type={type} onBack={onBack} />
      </form>
    </Paper>
  );
};

export default FieldList;
